// BookCall Model - fetches the qualified-creator booking step for the current
// creator. The backend owns qualification, AM routing, the per-environment
// meeting URL, and the prefill identity (GRW-9).

import { useGetBookingStepQuery } from 'generated/graphql';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { Async } from '@client/new/helpers/types';
import { useAsyncQuery } from '@client/new/helpers/gql';
import { BookingStep } from './BookCall.types';
import { toBookingStep } from './BookCall.mappers';

export const useBookCallModel = (): Async<BookingStep> => {
  const creatorId = useInfluencerId();

  const res = useGetBookingStepQuery({
    variables: { creatorId: String(creatorId) },
    fetchPolicy: 'network-only',
  });

  const { data } = useAsyncQuery(res, 'GetBookingStep', toBookingStep);

  return data;
};
